module.exports = __webpack_public_path__ + "static/assets/36f2a11077334ef49aea0fc08758de06.svg";